import { render, staticRenderFns } from "./CampDistributions.vue?vue&type=template&id=fbf5ddf2&"
import script from "./CampDistributions.vue?vue&type=script&lang=js&"
export * from "./CampDistributions.vue?vue&type=script&lang=js&"
import style0 from "./CampDistributions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports